import { ClassDetailsQuery_ActivityFragment } from "@outschool/gql-frontend-generated";
import React from "react";

import SelfPacedAvailableNow from "../subcomponents/SelfPacedAvailableNow";
import AvailableTimes from "./AvailableTimes";

export function AvailableTimesWrapper({
  activity,
  isOrganizationEnrollment,
  onClickMoreLikeThis
}: {
  activity: ClassDetailsQuery_ActivityFragment;
  isOrganizationEnrollment: boolean;
  onClickMoreLikeThis: () => void;
}) {
  return activity.isSelfPaced ? (
    <SelfPacedAvailableNow activity={activity} />
  ) : (
    <AvailableTimes
      activity={activity}
      isOrganizationEnrollment={isOrganizationEnrollment}
      onClickMoreLikeThis={onClickMoreLikeThis}
    />
  );
}
